module.exports = __webpack_public_path__ + "media/images/homepage/ground-bg-cea0d550f63df43f51337eca67ec21af.jpg";